import RegisterJWT from "../components/RegisterJWT";
import React from "react";

const RegisterPageV2 = () => {



    return (
        <div id="registerPage" className="container-fluid"
        >

            <div className="container">
                <div className="row">
                    <div className="col s2"></div>
                    <div className="col s8">
                        <p id="PageTitleRegister"> CREATE ACCOUNT</p>
                        {/*<p> Please complete all mandatory fields.</p>*/}
                    </div>
                    <div className="col s2"></div>
                </div>
            </div>

            <div className="row">

                {/*<Register/>*/}
                {/*<RegisterJWT/>*/}
                <RegisterJWT setCustomerInfo={(data) => console.log("Registration data:", data)}/>

            </div>
        </div>);

}

export default RegisterPageV2 ;